import { styled } from "styled-components";

export const Iframe = styled.iframe`
  position: absolute;
  width: 100%;
  height: 100%;
  border: none;
`;

export const Img = styled.img`
  position: absolute;
  width: 100%;
  height: 100%;
  border: none;
`;

export const StyledPlayButton = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 7vw;
  color: rgb(255, 255, 255, 0.6);
`;